const Environment = () => {
    var isLocalhost = Boolean(
        window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    var isQA = Boolean(
        window.location.href.match("source-qa") ||
        window.location.href.match("qa.")
    );

    var isSource = Boolean(
        window.location.href.match("source-")
    );

    return {
        isLocalhost: isLocalhost,
        isQA: isQA,
        isTest: (isQA || isLocalhost),
        isSource: isSource
    };
}

const switchURLapi = (LocalHost, QADomain, PRODDomain) => {
    if (Environment().isLocalhost) {
        return LocalHost;
    } else {
        if (Environment().isQA) {
            return QADomain;
        } else {
            if (Environment().isQA) {
                return QADomain;
            } else {
                return PRODDomain;
            }
        }
    }
}

const _Redirect = (url) => {
    var backtrace = (url) => {
        var tree = "";
        for (var i = 0; i < url.split("/").length; i++) {
            tree += "../";
        }
        return tree;
    }
    window.location.href = `/${window.location.href.indexOf("#") > -1 ? `#/${url}` : url}`;
}

const apiURL = switchURLapi("http://localhost:51384/api/",
    window.location.protocol + "//" + window.location.hostname + "/mshort/content/API/electionspolls/api/",
    window.location.protocol + "//" + window.location.hostname + "/mshort/content/API/electionspolls/api/");

export {
    Environment,
    apiURL,
    _Redirect
}


// WEBPACK FOOTER //
// ./src/Components/Services/Base.js